import { render, staticRenderFns } from "./CollectionsSearch.vue?vue&type=template&id=15a158e1"
import script from "./CollectionsSearch.vue?vue&type=script&lang=js"
export * from "./CollectionsSearch.vue?vue&type=script&lang=js"
import style0 from "./CollectionsSearch.vue?vue&type=style&index=0&id=15a158e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports